import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export const ContactHero = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-muted/50 to-background">
      <div className="max-w-4xl mx-auto px-4 py-24 md:py-32 text-center">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-4xl md:text-6xl font-bold mb-6 text-foreground"
        >
          Get a Free Growth Audit
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="text-lg md:text-xl text-muted-foreground mb-4 max-w-2xl mx-auto"
        >
          We'll show you exactly where you're losing leads—and how to turn more of them into booked customers.
        </motion.p>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="text-muted-foreground"
        >
          No fluff. Just actionable insights you can use immediately.
        </motion.p>
      </div>
    </section>
  );
};
